import { Directive, Inject, Input, Optional, Host, OnInit, OnDestroy, Self, ComponentRef, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';

import { NgControl } from '@angular/forms';
import { Observable, EMPTY, merge } from 'rxjs';
import { untilDestroyed } from 'ngx-take-until-destroy';

import { FORM_ERRORS } from './form-errors';
import { FormSubmitDirective } from './form-submit.directive';
import { ControlErrorComponent } from './control-error/control-error.component';
import { ControlErrorContainerDirective } from './control-error-container.directive';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[formControl], [formControlName]'
})
export class ControlsErrorsDirective implements OnInit, OnDestroy {

    constructor(
        vcr: ViewContainerRef,
        private resolver: ComponentFactoryResolver,
        @Optional() controlErrorContainer: ControlErrorContainerDirective,
        @Optional() @Host() private form: FormSubmitDirective,
        @Inject(FORM_ERRORS) private errors,
        @Self() private controlDir: NgControl
    ) {
        // console.log({e: "ControlsErrorsDirective::ctor", vcr: vcr, form: form, errors: errors, controlDir: controlDir })
        this.submit$ = this.form ? this.form.submit$ : EMPTY;
        this.container = controlErrorContainer ? controlErrorContainer.vcr : vcr;
    }

    submit$: Observable<Event>;
    @Input() customErrors = {};
    ref: ComponentRef<ControlErrorComponent>;
    container: ViewContainerRef;
    get control() {
        return this.controlDir.control;
    }

    ngOnInit() {
        // console.log({e: 'ControlsErrorsDirective::OnInit ', c: this.control});
        merge(
            this.submit$,
            this.control.valueChanges
        ).pipe(
            untilDestroyed(this)
        ).subscribe(() => {
            const controlErrors = this.control.errors;
            // console.log({e: 'ControlsErrorsDirective::OnValueChangeOrSubmit', controlErrors});
            if (controlErrors) {
                const firstKey = Object.keys(controlErrors)[0];
                const getError = this.errors[firstKey];
                let text = 'Invalid input.';
                if (getError) {
                    text = getError(controlErrors[firstKey]);
                }
                this.setError(text);
            } else if (this.ref) {
                this.setError(null);
            }
        });
    }

    ngOnDestroy(): void { }

    setError(text: string) {
        if (!this.ref) {
            const factory = this.resolver.resolveComponentFactory(ControlErrorComponent);
            this.ref = this.container.createComponent(factory);
        }
        this.ref.instance.text = text;
    }
}
